import styled from 'styled-components'
import { TabPanel } from 'components/TabNavigation'
import { colors } from 'theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const TabsContainer = styled.div`
  background-color: ${colors.color100};
`

export const StyledTabPanel = styled(TabPanel)`
  padding-top: 5px;
  &.filled {
    background-color: ${colors.color200};
  }
`
